import React from "react";

export function PreNode({ classes = "", children }) {
  if (typeof children === "string")
    return (
      <pre
        className={`pre-node-description ${classes}`}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    );
  else
    return <pre className={`pre-node-description ${classes}`}>{children}</pre>;
}
